import React from 'react';
import { CheckIcon } from 'lucide-react';
import { foundingBenefits, foundingPerks, foundingPlans, foundingCommitments } from '../../data/foundingOffer';
export function FoundingOffer() {
  return <div className="space-y-20 md:space-y-24" data-id="element-306" data-mp="3of7ofypobqn9">
      {/* What founding members get */}
      <section aria-labelledby="founding-benefits-heading" data-id="element-307" data-mp="3jhfsmtlwrkds">
        <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-purple-700 mb-4" data-id="element-308" data-mp="3jj0msi4b91b4">
          Your founding offer
        </p>
        <h2 id="founding-benefits-heading" className="font-serif text-3xl md:text-4xl text-charcoal leading-tight" data-id="element-309" data-mp="fzxnwv1fmthl">
          What you have — permanently.
        </h2>

        <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-310" data-mp="6axkmzfwdbxl">
          {foundingBenefits.map(benefit => <div key={benefit.title} className="rounded-2xl border border-purple-200 border-t-2 border-t-purple-600 bg-white px-6 py-5" data-id="element-311" data-mp="13q1u9a6097ca">
              <h3 className="font-serif text-lg text-charcoal" data-id="element-312" data-mp="316yeo6b1izxv">
                {benefit.title}
              </h3>
              <p className="mt-2 text-sm text-charcoal/70 leading-relaxed" data-id="element-313" data-mp="3662rd6x6bfsy">
                {benefit.description}
              </p>
            </div>)}
        </div>

        <div className="mt-6 rounded-2xl border-l-2 border-purple-600 bg-purple-50 px-6 py-6" data-id="element-314" data-mp="2wfq7zi13hsoe">
          <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-purple-800 mb-4" data-id="element-315" data-mp="2ig8farkohv9r">
            What you keep — forever
          </p>
          <ul className="grid gap-x-8 gap-y-2.5 sm:grid-cols-2" data-id="element-316" data-mp="2milmlkf2q18n">
            {foundingPerks.map(perk => <li key={perk} className="flex items-start gap-2.5 text-sm text-charcoal/80 leading-relaxed" data-id="element-317" data-mp="28jvlltp4vhf0">
                <CheckIcon aria-hidden="true" className="mt-0.5 w-4 h-4 shrink-0 text-purple-700" data-id="element-318" data-mp="6q60avx23780" />
                {perk}
              </li>)}
          </ul>
        </div>
      </section>

      {/* Plans */}
      <section aria-labelledby="founding-plans-heading" data-id="element-319" data-mp="a6913auz92nf">
        <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-purple-700 mb-4" data-id="element-320" data-mp="58phdvfifxo3">
          Choose your plan
        </p>
        <h2 id="founding-plans-heading" className="font-serif text-3xl md:text-4xl text-charcoal leading-tight" data-id="element-321" data-mp="c8v76rvftdn">
          Your founding rate — locked in.
        </h2>
        <p className="mt-4 max-w-2xl text-base text-charcoal/70 leading-relaxed" data-id="element-322" data-mp="t0xo4iirwseb">
          Two months free to start. Beginning Month 3, you're billed at your
          founding rate — locked in for life. For Bloom, Thrive, and Collective
          tiers, each practitioner on the plan must be individually verified
          before their profile is activated.
        </p>

        <div className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-323" data-mp="1bqvw6ymkmlhy">
          {foundingPlans.map(plan => <div key={plan.name} className={`relative flex flex-col rounded-2xl px-6 py-6 ${plan.highlighted ? 'border-2 border-purple-600 bg-purple-50' : 'border border-purple-200 bg-white'}`} data-id="element-324" data-mp="16xjjnmv6255k">
              {plan.highlighted && <span className="absolute -top-3 left-6 rounded-full bg-purple-700 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.12em] text-white" data-id="element-325" data-mp="1t7006zo8c0g0">
                  Most popular
                </span>}
              <h3 className="font-serif text-2xl text-charcoal" data-id="element-326" data-mp="226woh06pixaj">{plan.name}</h3>
              <p className="mt-1 text-sm text-charcoal/60" data-id="element-327" data-mp="26y6cjwclxskb">{plan.seats}</p>
              <p className="mt-4 font-serif text-3xl text-purple-800" data-id="element-328" data-mp="2bxriwru3x372">
                {plan.price}
                <span className="text-base text-purple-800/70" data-id="element-329" data-mp="2gwuhpujhud6l">
                  {plan.priceSuffix}
                </span>
              </p>
              <p className="mt-1 text-sm italic text-charcoal/50" data-id="element-330" data-mp="2lx07t6a47rmk">
                Locked for life
              </p>
              <ul className="mt-5 space-y-2.5" data-id="element-331" data-mp="3ilrc8rv5ncus">
                {plan.features.map(feature => <li key={feature} className="flex items-start gap-2.5 text-sm text-charcoal/80 leading-relaxed" data-id="element-332" data-mp="3dnpqu0a9b1g5">
                    <CheckIcon aria-hidden="true" className="mt-0.5 w-4 h-4 shrink-0 text-purple-700" data-id="element-333" data-mp="3nf3p64qh1v7p" />
                    {feature}
                  </li>)}
              </ul>
              {plan.note && <p className="mt-5 pt-4 border-t border-purple-200 text-sm italic text-charcoal/60 mt-auto" data-id="element-334" data-mp="38pei5svp6wzi">
                  {plan.note}
                </p>}
            </div>)}
        </div>
      </section>

      {/* Commitments */}
      <section aria-labelledby="founding-commitments-heading" data-id="element-335" data-mp="o0rvdr41zjob">
        <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-purple-700 mb-4" data-id="element-336" data-mp="jwk7fw5f67r5">
          Your commitments
        </p>
        <h2 id="founding-commitments-heading" className="font-serif text-3xl md:text-4xl text-charcoal leading-tight" data-id="element-337" data-mp="rj7ggpv7g1jy">
          Founding membership is a two-way relationship.
        </h2>

        <ol className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-338" data-mp="mhi2b1cor7rn">
          {foundingCommitments.map((commitment, index) => <li key={commitment} className="flex items-start gap-3 text-base text-charcoal/80 leading-relaxed" data-id="element-339" data-mp="1a72oru81sn5o" data-mpi={index}>
              <span aria-hidden="true" className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-purple-700 text-[11px] font-semibold text-white" data-id="element-340" data-mp="1f89xbvi0lqde">
                {index + 1}
              </span>
              {commitment}
            </li>)}
        </ol>

        <p className="mt-6 text-sm text-charcoal/55 leading-relaxed" data-id="element-341" data-mp="1xx6rlzdewivm">
          To maintain founding status, subscriptions must remain active. If a
          membership is cancelled and later restarted, the practitioner returns
          at the current market rate.
        </p>
      </section>
    </div>;
}